<div class="ft-delete-wrap">
  @if (deleteOptions?.showSpinner) {
  <div class="spinner-delete-wrapper">
      <mat-spinner [diameter]="21"></mat-spinner>
  </div>
  }
  @if (!deleteOptions?.showSpinner) {
  <button type="button" mat-icon-button color="primary"
      (click)="deleteDoc();"
      class="commandbar-item material-icons hidden-print"
      tooltip-placement="bottom" tooltip="Delete" title="Delete document"

      aria-label="Delete Document"
      id="deleteButton">
      <mat-icon>delete</mat-icon>
  </button>
  }
</div>
